import { SearchX } from "lucide-react";

export default function SearchEmpty({ searchTerm }: { searchTerm: string }) {
  return (
    <>
      <div className="w-[36px] h-[36px] rounded-[8px] mb-[15px] bg-white border border-border flex items-center justify-center">
        <SearchX height={20} width={20} color="#09090B" />
      </div>

      <h3 className="text-base font-semibold mb-[4px]">
        {searchTerm
          ? `"${searchTerm}" ile eşleşen yanıt bulunamadı`
          : "Arama sonucu bulunamadı"}
      </h3>
      <p className="text-[14px] font-600 text-muted-foreground">
        Farklı bir anahtar kelime deneyin veya aramayı temizleyin.
      </p>
    </>
  );
}
